import { AbstractDestroyable, DestroyableScheduler } from '@deqo/foundation';
import { ResultData } from './ApiTypes';

export class RequestTerminal<T> extends AbstractDestroyable {

    private nextBatch = [] as T[];
    private working = false;
    private scheduler = new DestroyableScheduler();

    constructor(private submitBatch: (payload: T[]) => Promise<ResultData>) {
        super();
        this.burden(this.scheduler);
    }

    public queueNext(patch: T, hold?: boolean) {
        this.nextBatch.push(patch);
        if (!hold) {
            this.scheduler.timeout('submit', 500,
                () => this.maybeSubmitNextBatch().then(() => { })
            );
        }
    }

    public flushNext() {
        this.scheduler.timeout('submit', 0,
            () => this.maybeSubmitNextBatch().then(() => { })
        );
    }

    private async maybeSubmitNextBatch() {
        if (this.working) return;
        if (this.nextBatch.length === 0) return;

        try {
            const payload = this.nextBatch.splice(0, this.nextBatch.length);
            const result = await this.submitBatch(payload);
            if (!result.ok) {
                // this.alerts.invoke({
                //     type: 'error',
                //     body: result.errors.join('\n'),
                //     delay: 10000,
                // });
            }
        }
        catch (err) {
            console.error('Failed to submit batch', err);
        }
        finally {
            this.working = false;
            this.maybeSubmitNextBatch();
        }
    }
}
